<template>
    <div>
        <base-layout :hideHeader="!isShowHeader" title="">
            <!--<template slot="header-right">
                <i class="dmicon dm-guanbi1" @click="$router.back()"></i>
            </template>-->
            <template slot="main">
                <div class="docs" v-show="isShowDocs">
                    <h2 v-if="showTitle" style="text-align: center;">附件:历史会员等级、权益和积分的承接处理</h2>
                    <p class="info-title">一、历史会员的处理原则</p>
                    <p>
                        1.历史会员指在《会员章程》（以下简称之“本章程”）生效前（不含当日）、依据当时施行的《达美乐会员积分计划》加入达美乐达人荟的会员。
                    </p>
                    <p>
                        2.历史会员的等级承接：
                    </p>
                    <ul>
                        <li>
                            (1)本章程生效前会员等级为普通会员的历史会员，以本章程生效日倒推12个自然月期间所累计获得积分作为承接评定会员等级的依据。
                        </li>
                        <li>
                            (2)本章程生效前会员等级为VIP会员的历史会员，将在本章程生效后被自动承接为尊享VIP，且会员权益和会员等级有效期维持不变。
                        </li>
                        <li>
                            (3)具体标准见下：
                            <img src="./_img/4.png"/>
                        </li>
                    </ul>
                    <p class="info-title">
                        二、历史会员按照所承接的会员等级，遵循《会员章程》之约定享受权益。
                    </p>
                    <p class="info-title">
                        三、历史会员回馈礼活动
                    </p>
                    <ul>
                        <li>
                            1.为了答谢历史会员对达美乐的既往支持和信任，值此会员系统升级，历史会员在活动期限(2020年3月16日至2021年3月15日)期间取得积分累计达到300或以上时，将获得一份回馈礼一次。
                        </li>
                        <li>
                            2.每名达人荟历史会员仅可获取一次一份回馈礼。
                        </li>
                        <li>
                            3.当期回馈礼名称为“可可布朗尼比萨优惠券”，对应内容为“7英寸可可布朗尼比萨一个”兑换券1张，第一期为20000份，追加第二期72000份，2020年7月9日追加第三期200000份，送完即止，2020年8月27日至11月25期间该券使用条件为任意消费后使用。优惠券价值的计算依据是一个7英寸可可布朗尼比萨的餐厅菜单售价为28元人民币。
                        </li>
                        <li>
                            4.领取方式：回馈礼将在会员符合获得条件的当日，按照达到领取条件的系统时间顺序，依次以电子券的形式由系统发放至会员卡券包账户。
                        </li>
                        <li>
                            5.使用条件：该兑换券须单笔订单购买餐品（不含服务）满人民币50元（以用券时系统在订单页面、按会员使用不同优惠而实时显示“已购商品”的总金额为准据）才可以使用。
                        </li>
                        <li>
                            6.使用限制：每笔订单可使用最多2张优惠券（包括产品兑换券、折扣券或其他优惠的礼券）。该兑换券可与其他优惠活动同时享受。不可转赠、不可折换成现金或积分；如使用该兑换券的订单发生退款，该兑换券将退回会员账户。
                        </li>
                        <li>
                            7.适用渠道：回馈礼仅限达美乐自有线上订餐渠道{达美乐官网、达美乐微信公众号、达美乐App、达美乐支付宝生活号、达美乐微信小程序等等，下文同义}使用，不适用于其他订餐渠道。
                        </li>
                        <li>
                            8.适用菜品：回馈礼所兑换比萨仅限经典手拍和轻巧薄脆两种饼底(不适用于特殊饼皮及额外添加配料)。
                        </li>
                        <li>
                            9.使用期限：该项回馈礼有效期为获券当日起的30天，逾期未用视为放弃该项回馈礼。过期作废后不予补发。
                        </li>
                        <li>
                            10.如您发现未收到回馈礼券，或使用回馈礼券的订单取消后但未收到回馈礼券退回，请会员在服务时间段内向达美乐客服中心电话4001-597-597查询和处理。
                        </li>
                        <li>
                            11.回馈礼相关宣传中“1元=1积分”指《会员章程》第四条约定的“消费获取积分: 消费1元人民币=1积分，不足1元部分四舍五入计算积分。积分计算以会员在达美乐自有订餐渠道、在会员登录状态下的订单实付金额计算, 且不含本章程规定不得积分的情况”。提醒您注意不能获取积分的情形。
                        </li>
                    </ul>
                    <h2 style="text-align: right;padding-right: 10px;">
                        达美乐中国
                    </h2>
                </div>

            </template>
        </base-layout>
    </div>
</template>
<script>
	import Vue from 'vue'

	// 隐私协议更新版本日期
	const versionTime = '2019年9月9日';
	const PrivacyProtocolName = '__cache__key__PrivacyProtocol__'

	import baseLayout from "@comm/view/layout/baseLayout";

	export default {
		name: 'systemProtocolMemberRulesAppendix1',
		props: {
			isShowHeader: {
				type: Boolean,
				default: true
			},
			showTitle: {
				type: Boolean,
				default: true
			},
		},
		data() {
			return {
				versionTime,
				isShowDocs: true
			};
		},
		components: {
			baseLayout
		},
		methods: {
			onShowInfo() {
				this.isShowDocs = !this.isShowDocs;
				this.$nextTick(() => {
					let dialogBox = document.querySelector('.dialog-body');
					let viewBox = document.querySelector('.child-view');
					dialogBox ? dialogBox.scrollTop = '0px' : viewBox.scrollTop = '0px'
				})

			}
		}
	};

	// 版本检查
	function checkVersion() {
		let oldVersionTime = Vue.$localStore.get(PrivacyProtocolName);
		// 对比版本是否一致
		if (oldVersionTime == versionTime) {
			// 表示无更新
			return false;
		}
		// 表示更新
		return true;
	}

	// 更新版本
	function updateVersion() {
		Vue.$localStore.set(PrivacyProtocolName, versionTime);
	}

	export {
		versionTime,
		checkVersion,
		updateVersion,
	}
</script>

<style lang="scss" scoped>


    * {
        font-size: 12px;
    }
    .docs {
        padding: 15px;
        height: 100%;
        overflow-y: scroll;
    }

    h2 {
        color: #333;
        font-size: 16px;
        font-weight: 700;
        padding: 10px 0;
    }

    h3 {
        color: #af1515;
        font-size: 14px;
        font-weight: 700;
        padding: 10px 0;
    }

    .info-text {
        font-size: 14px;
        padding: 5px 0;
    }

    .info-title {
        font-size: 14px;
        font-weight: 700;
    }

    .btn-box {
        text-align: center;
    }

    .btn-back {
        background-color: #dd0404;
        border: none;
        padding: 10px 40px;
        color: #fff;
        border-radius: 5px;

    }

    .btn-container {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    button.back {
        color: white;
        border: none;
        outline: none;
        width: 100px;
        padding: 5px 10px;
        background-color: red;
    }

    .underline {
        text-decoration: underline;
    }

    .normal {
        font-size: 14px;
    }

    .red {
        /*color: red;*/
    }

    .bold {
        font-weight: bold;
    }

    .padding-top {
        padding-top: 10px;
    }

    p, h3, h2 {
        &.warin {
            color: red;
        }
    }

    .doc-title {
        text-align: center;
    }

    .sub-title {
        font-size: 13px;
    }

    .info-text {
        font-size: 14px;
        padding: 5px 0;
    }

    .info-title {
        font-size: 14px;
        font-weight: 700;
        padding-top: 5px;
    }

    .btn-box {
        text-align: center;

    }

    .btn-back {
        background-color: #dd0404;
        border: none;
        padding: 10px 40px;
        color: #fff;
        border-radius: 5px;

    }

    .btn-container {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    button.back {
        color: white;
        border: none;
        outline: none;
        width: 100px;
        padding: 5px 10px;
        background-color: red;
    }

    p, h3, h2 {
        &.warin {
            color: red;
        }
    }

    img {
        width: 100%;
    }

    .link {
        font-style: italic;
        text-decoration: underline;
    }

    .bold {
        font-weight: bold;
    }
</style>